/* GJ88 Snack Box — storefront behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) => 'Rp' + Math.round(cents / 100).toLocaleString('id-ID');

  /* ---------- toast ---------- */
  const toastEl = $('[data-toast]');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---------- overlays (menu, cart) ---------- */
  let lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    const focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    if (!$('.menu:not([hidden]), .drawer:not([hidden])')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-menu],[data-close-menu],[data-open-cart],[data-close-cart],[data-open-search],[data-close-search]');
    if (!t) return;
    if (t.matches('[data-open-menu]')) openLayer($('[data-menu]'));
    if (t.matches('[data-close-menu]')) closeLayer($('[data-menu]'));
    if (t.matches('[data-open-cart]')) { e.preventDefault(); openLayer($('[data-cart-drawer]')); }
    if (t.matches('[data-close-cart]')) closeLayer($('[data-cart-drawer]'));
    if (t.matches('[data-open-search]')) openSearch();
    if (t.matches('[data-close-search]')) closeSearch();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeLayer($('[data-menu]'));
    closeLayer($('[data-cart-drawer]'));
    closeSearch();
  });

  /* ---------- header shadow on scroll ---------- */
  const header = $('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- predictive search ---------- */
  const searchForm = $('[data-search]');
  const searchInput = $('[data-search-input]');
  const results = $('[data-search-results]');
  function openSearch() {
    if (!searchForm) return;
    searchForm.classList.add('is-open');
    searchInput.focus();
  }
  function closeSearch() {
    if (!searchForm) return;
    searchForm.classList.remove('is-open');
    if (results) results.hidden = true;
  }
  let searchTimer, searchCtrl;
  if (searchInput && results) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { results.hidden = true; return; }
      searchTimer = setTimeout(async () => {
        if (searchCtrl) searchCtrl.abort();
        searchCtrl = new AbortController();
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url, { signal: searchCtrl.signal });
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
          results.innerHTML = products.length
            ? products.map((p) => `<a class="sr-item" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}${p.image.includes("?") ? "&" : "?"}width=96" alt="" width="48" height="48" loading="lazy">` : ''}<span><span class="sr-item__title">${esc(p.title)}</span><span class="sr-item__price">${money(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('')
              + `<a class="sr-all" href="${root}search?type=product&q=${encodeURIComponent(q)}">Lihat semua hasil untuk “${esc(q)}”</a>`
            : `<p class="sr-empty">Tidak ada produk untuk “${esc(q)}”. Coba kata lain.</p>`;
          results.hidden = false;
        } catch (err) { /* aborted or offline: keep the plain form working */ }
      }, 180);
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-search]') && !e.target.closest('[data-open-search]')) closeSearch(); });
  }

  /* ---------- cart (order list) ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach((b) => {
      b.textContent = n;
      b.hidden = n === 0;
      b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
    });
  }
  async function refreshCart(sectionsHtml) {
    let html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) {
      const res = await fetch(`${root}?sections=cart-drawer`);
      html = (await res.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    const current = $('[data-cart-drawer]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      setCount(parseInt(fresh.dataset.count || '0', 10));
    }
    const page = $('[data-cart-page]');
    if (page) location.reload();
  }
  async function addToCart(form, button) {
    const fd = new FormData(form);
    const body = { items: [{ id: Number(fd.get('id')), quantity: Math.max(1, Number(fd.get('quantity') || 1)) }], sections: 'cart-drawer' };
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Gagal menambahkan');
      await refreshCart(data.sections);
      if (button) { button.classList.add('is-added'); setTimeout(() => button.classList.remove('is-added'), 900); }
      const title = (data.items && data.items[0] && data.items[0].product_title) || 'Produk';
      toast(`✓ ${title} masuk daftar pesanan`);
    } catch (err) {
      toast(err.message || 'Gagal menambahkan, coba lagi');
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    const line = b.closest('.line');
    if (line) line.classList.add('is-busy');
    try {
      const res = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.lineChange), quantity: Number(b.dataset.qty), sections: 'cart-drawer' }) });
      const data = await res.json();
      await refreshCart(data.sections);
    } catch (err) {
      toast('Gagal mengubah jumlah');
      if (line) line.classList.remove('is-busy');
    }
  });

  /* ---------- copy order list ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-copy-order]');
    if (!b) return;
    try {
      await navigator.clipboard.writeText(b.dataset.copyText.replace('__QTY__', '1'));
      toast('✓ Daftar pesanan disalin');
    } catch (err) {
      toast('Tidak bisa menyalin di browser ini');
    }
  });

  /* ---------- product page ---------- */
  const product = $('[data-product]');
  if (product) {
    const form = $('[data-product-form]', product);
    const qty = $('[data-qty]', product);
    const pack = Number(product.dataset.pack || 0);
    const waLink = $('[data-wa-link]', product);
    const syncWa = () => {
      if (!waLink) return;
      const text = waLink.dataset.waTemplate.replace('__QTY__', String(Math.max(1, Number(qty.value) || 1)));
      waLink.href = `https://wa.me/${waLink.dataset.waNumber}?text=${encodeURIComponent(text)}`;
    };
    $$('[data-step]', product).forEach((b) => b.addEventListener('click', () => {
      qty.value = Math.min(999, Math.max(1, (Number(qty.value) || 1) + Number(b.dataset.step)));
      syncWa();
    }));
    if (qty) qty.addEventListener('input', syncWa);

    const select = $('[data-variant-select]', product);
    if (select) select.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      $('[data-variant-id]', product).value = opt.value;
      $$('[data-price]').forEach((p) => { p.textContent = opt.dataset.price; });
      const per = $('[data-price-per]', product);
      if (per && pack > 1) per.textContent = `≈ ${money(Number(opt.dataset.cents) / pack)}/pcs · isi ${pack} pcs`;
      const available = opt.dataset.available === 'true';
      const add = $('[data-add-button]', product);
      add.disabled = !available;
      add.querySelector('[data-add-label]').innerHTML = available ? 'Tambah<span class="hide-sm"> ke pesanan</span>' : 'Stok habis';
      const url = new URL(location.href); url.searchParams.set('variant', opt.value); history.replaceState(null, '', url);
    });

    // gallery: thumbnails scroll the track, the track's position marks the thumbnail
    const track = $('[data-gallery-track]', product);
    const thumbs = $$('[data-gallery-to]', product);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      track.scrollTo({ left: track.clientWidth * Number(t.dataset.galleryTo), behavior: 'smooth' });
    }));
    if (track && thumbs.length) track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
    }, { passive: true });

    // sticky buy bar once the main button scrolls away
    const bar = $('[data-buy-bar]');
    const addBtn = $('[data-add-button]', product);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      $('[data-buy-bar-add]', bar).addEventListener('click', (e) => addToCart(form, e.currentTarget));
    }
  }

  /* ---------- product recommendations ---------- */
  const rec = $('[data-recommendations]');
  if (rec && rec.dataset.url) {
    fetch(rec.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { rec.innerHTML = fresh.innerHTML; observeReveals(rec); }
      else rec.remove();
    }).catch(() => rec.remove());
  }

  /* ---------- sort select auto-submit ---------- */
  $$('[data-auto-submit] select').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* ---------- reveal on scroll ---------- */
  let io;
  function observeReveals(scope = document) {
    const els = $$('.reveal:not(.is-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    io = io || new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }
  observeReveals();
})();
